
export const SET_COMPANY = 'SET_COMPANY';
export const SET_OFFERS = 'SET_OFFERS';
export const SET_STATES = 'SET_STATES';
export const SET_ACADEMIC_PROGRAMS = 'SET_ACADEMIC_PROGRAMS';
export const SET_SCHEDULES = 'SET_SCHEDULES';
export const SET_CONTRACT_TYPES = 'SET_CONTRACT_TYPES';
export const SET_OFFER = 'SET_OFFER';
export const SET_EDITING_OFFER = 'SET_EDITING_OFFER';
export const SET_OFFER_PREVIEW = 'SET_OFFER_PREVIEW';
export const SET_APPLICATIONS = 'SET_APPLICATIONS';
export const SET_CANDIDATE = 'SET_CANDIDATE';
export const SET_BUSINESS_SECTORS = 'SET_BUSINESS_SECTORS';
export const SET_FORMATIVE_FAMILIES = 'SET_FORMATIVE_FAMILIES';
export const SET_COMPANY_OFFERS_EMULATION = 'SET_COMPANY_OFFERS_EMULATION';
export const SET_COMPANY_OFFERS_COUNT = 'SET_COMPANY_OFFERS_COUNT';
export const SET_COMPANY_CANDIDATES_COUNT = 'SET_COMPANY_CANDIDATES_COUNT';
export const SET_COMPANY_OFFERS_FILTER = 'SET_COMPANY_OFFERS_FILTER';
export const SET_COMPANY_OFFERS_APPLICATIONS_FILTER = 'SET_COMPANY_OFFERS_APPLICATIONS_FILTER';
